import { Col, Form } from "react-bootstrap";
import { toast } from "react-toastify";
import { useContext, useEffect, useState } from 'react';
import hocFrom from "../../../components/forms/HocFrom";
import InputControl from "../../../components/inputs/InputControl";
import InputNumber from "../../../components/inputs/InputNumber";
import Loader from "../../../components/layout/Loader";
import { Table } from "antd";
import DashboardContext from "../../../Context"
import Axios from 'axios';
import { AlignType } from 'rc-table/lib/interface'
import InputDate from "../../../components/inputs/InputDate";
import { Collapse } from 'antd';
import { Button, Space } from 'antd';

const DiscountCouponReport = () => {

    const { urldashboard, authentication } = useContext(DashboardContext);
    const [data, setDataFech] = useState([]);
    const [loading, setLoading] = useState(true);
    const [discountCodeSearch, setDiscountCodeSearch] = useState('');
    const [fromDate, setFromDate] = useState(undefined);
    const [toDate, setToDate] = useState(undefined);
    const [totoalRecord, setTotalRecord] = useState(0);
    const [excelLoading, setExcelLoading] = useState(false);
    const [pagination, setPagination] = useState({
        page: 1,
        pageSize: 50,
    });

    useEffect(() => {
        datafeching({ page: pagination.page, pageSize: pagination.pageSize, discountCode: discountCodeSearch, fromDate: undefined, toDate: undefined })
        return () => {

        }
    }, [])

    const handelValueFromDate = (name, value) => {
        setFromDate(value);
    }

    const handelValueToDate = (name, value) => {
        setToDate(value);
    }

    const getExcelReport = async ({ page, pageSize, discountCode, fromDate, toDate }) => {

        setExcelLoading(true);

        try {

            let url = '/DiscountCouponReport/GetDiscountCodePDFReport';

            const res = await Axios.post(urldashboard + url, JSON.stringify({ page, pageSize, discountCode, fromDate, toDate }), {
                headers: {
                    "Authorization": authentication,
                    "Content-Type": "application/json",
                }, responseType: 'arraybuffer'
            })

            let blob = new Blob([res.data], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" }); // change resultByte to bytes
            let link = document.createElement("a");
            link.href = window.URL.createObjectURL(blob);
            link.download = "DiscountCouponReport.pdf";
            link.click();

            setExcelLoading(false);
        } catch (error) {
            setExcelLoading(false);
            //handelerrors(error)
        }
    }

    const getExcel = () => {

        setExcelLoading(true);
        getExcelReport({
            page: pagination.page,
            pageSize: pagination.pageSize,
            discountCode: discountCodeSearch,
            fromDate: fromDate,
            toDate: toDate
        });
    }

    const datafeching = async ({ page, pageSize, searchDiscountCode, fromDate, toDate }) => {

        setLoading(true);

        try {

            let url = '/DiscountCouponReport/get';

            const res = await Axios.post(urldashboard + url, JSON.stringify({
                page,
                pageSize,
                discountCode: searchDiscountCode,
                fromDate,
                toDate
            }), {
                headers: {
                    "Authorization": authentication,
                    "Content-Type": "application/json"
                }
            })

            const data = await res.data

            setDataFech(data.data)

            setTotalRecord(data.totalRecord)

            setPagination({
                page: page,
                pageSize: pageSize,
                total: data.totalRecord, // 200 is mock data, you should read it from server
                // total: data.totalCount,
            });

            setLoading(false);
        } catch (error) {
            setLoading(false);
            alert('خطایی رخ داده است!')
            setDataFech([]);
        }
    }

    const handleTableChange = (newPagination, filters, sorter) => {
        // datafeching({
        //     sortField: sorter.field,
        //     sortOrder: sorter.order,
        //     pagination: newPagination,
        //     ...filters,
        // });
        // setPagination({
        //     page: newPagination.current,
        //     pageSize: newPagination.pageSize
        // });
        //let page = 0;
        datafeching({
            page: newPagination.current,
            pageSize: newPagination.pageSize,
            serachDiscountCode: discountCodeSearch,
            fromDate: fromDate,
            toDate: toDate
        });
    };

    const columns = [
        {
            title: 'ردیف',
            dataIndex: 'index',
            key: 'index',
            width: '1%',
            render: (item, record, index) => (<>{(index + 1) + ((pagination?.page - 1) * pagination?.pageSize)}</>)
        },
        {
            title: 'کد تخفیف',
            dataIndex: 'discountCode',
            key: 'discountCode',
            width: '3%'
        },
        {
            title: 'تعداد استفاده',
            dataIndex: 'numberOfUsed',
            key: 'numberOfUsed',
            width: '3%'
        },
        {
            title: 'گروه و تعداد استفاده',
            dataIndex: 'groupUsed',
            key: 'groupUsed',
            width: '7%',
            render: (item, record, index) => (<>{item.map(x => (<div>{x.groupTitle}<span>({x.numberOfUsed})</span></div>))}</>)
        }
    ];

    const discountCodeSerach = (event) => {
        setDiscountCodeSearch(event.target.value);
    }


    const search = () => {
        datafeching({
            page: 1,
            pageSize: 20,
            searchDiscountCode: discountCodeSearch,
            fromDate: fromDate,
            toDate: toDate
        })
    }

    const { Panel } = Collapse;

    const reset = () => {
        setFromDate(undefined)
        setToDate(undefined)
        setDiscountCodeSearch('')
        datafeching({
            page: 1,
            pageSize: 20,
            serachDiscountCode: '',
            fromDate: undefined,
            toDate: undefined
        })
    }

    return (
        <>

            <div style={{ display: 'flex', flexDirection: 'row' }}>

                <div style={{ flex: 1, marginLeft: 15 }}>

                    <Collapse defaultActiveKey={['0']} >
                        <Panel header="جستجو" key="1">

                            <div className="row">
                                <div className="col-md-4">
                                    <InputDate label='از تاریخ' name='fromDate' defaultValue={fromDate} handelValue={handelValueFromDate} />
                                </div>
                                <div className="col-md-4">
                                    <InputDate label='تا تاریخ' name='toDate' defaultValue={toDate} handelValue={handelValueToDate} />
                                </div>
                                <div className="col-md-4" style={{ marginTop: 30 }}>
                                    <input className="form-control" value={discountCodeSearch} onChange={discountCodeSerach} type='text' placeholder="جستجوی کد تخفیف"></input>
                                </div>
                            </div>

                            {/* <div style={{ display: "flex" }}>
                                <div className="col-md-4">
                                    <input className="form-control" value={orderLessCount} onChange={orderLessCountSearchChange} type='text' placeholder="تعداد سفارش کمتر از"></input>
                                </div>
                                <div className="col-md-4">
                                    <input className="form-control" value={orderMoreCount} onChange={orderMoreCountSearchChange} type='text' placeholder="تعداد سفارش بیشتر از"></input>
                                </div>
                            </div> */}

                            <div className="row" style={{ display: "flex", marginTop: 20 }}>
                                <div className="col-md-6">
                                    <Button
                                        type="primary"
                                        style={{ width: '100%' }}
                                        loading={loading}
                                        onClick={() => search()}
                                    >
                                        جستجو
                                    </Button>
                                </div>
                                <div className="col-md-6">
                                    <Button
                                        type="primary" danger ghost
                                        style={{ width: '100%' }}
                                        onClick={() => reset()}
                                    >
                                        پاک کردن فرم جستجو
                                    </Button>
                                </div>
                            </div>
                        </Panel>
                    </Collapse>

                </div>


                {
                    excelLoading ? <i class="fas fa-sync fa-spin">
                        <i style={{ fontSize: '40px', color: 'red' }} class="fa fa-file-excel-o" aria-hidden="true"></i>
                    </i> : <i style={{ fontSize: '40px', color: 'red' }} onClick={() => getExcel()} class="fa fa-file-pdf-o" aria-hidden="true"></i>
                }


            </div>

            <Table
                size="small"
                style={{ textAlign: 'right', marginTop: 20 }}
                rowClassName={(row, index) => 'center'}
                columns={columns}
                bordered={true}
                //rowKey={(record) => record.login.uuid}
                dataSource={data}
                pagination={pagination}
                loading={loading}
                onChange={handleTableChange}
            // expandable={{
            //     expandedRowRender: record => <p style={{ margin: 0 }}>{record.customerName}</p>,
            //     rowExpandable: record => record.customerName !== 'Not Expandable',
            // }}
            />
            <div style={{ marginTop: -40 }}>
                تعداد کل:{totoalRecord}
                <br />
                {/* جمع کل فروش:{totoalAmountSale.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") } */}
            </div>

        </>

    );
}

export default hocFrom(DiscountCouponReport);
